import React from "react";
import { Box, Button, Typography } from "@mui/material";
import ExtensionIcon from "@mui/icons-material/Extension";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import "./RTMEmptyState.css";

const RTMEmptyState = ({ onCreateMapping }) => {
  return (
    <Box className="modern-empty-wrapper">
      <div className="empty-badge">No Mappings Configured</div>

      <div className="empty-content">
        <div className="empty-illustration">
          <ExtensionIcon />
        </div>

        <div className="empty-text-group">
          <Typography className="empty-title">
            Configure Your RTM Mapping
          </Typography>

          <Typography className="empty-description">
            It looks like you haven't linked your Jira fields to the template yet.
            Create a mapping to start generating professional RTM reports and insights.
          </Typography>

          <div className="empty-action-area">
            <Button
              variant="contained"
              className="modern-create-btn"
              startIcon={<AddCircleOutlineIcon />}
              onClick={onCreateMapping}
            >
              Create New Mapping
            </Button>
          </div>
        </div>
      </div>
    </Box>
  );
};

export default RTMEmptyState;
